// import { useRoleAccess } from '../features/users/hooks/useRoleAccess';
import { useAuth } from '../../authentication/hooks/useAuth';
import { useState } from 'react';
import { Card, Heading, Text } from '@cleanpro/common-ui';

export default function AdminRBAC() {
  const { user } = useAuth();
  const [message] = useState('');

  const isAdmin = user?.isPlatformAdmin;

  if (!isAdmin) {
    return (
      <div className="p-8">
        <Card padding="lg" className="max-w-md mx-auto text-center">
          <Text variant="default" className="text-red-600">
            Access denied. Admins only.
          </Text>
        </Card>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto p-8">
      <Card padding="lg">
        <Heading level={2} className="mb-6">
          Admin Role Management
        </Heading>

        <div className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <Text variant="default" className="text-amber-800">
            Role assignment is now managed via Clerk organizations / JWT claims. Use the Clerk dashboard to change roles.
          </Text>
        </div>

        {message && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
            <Text variant="default" className="text-green-700">
              {message}
            </Text>
          </div>
        )}
      </Card>
    </div>
  );
}
